<!--
 * @Author: zhubincong
 * @Date: 2020-3-9 19:41:31
 * @Desc: 区域预警分布统计
 -->
<template>
  <ViewPanel title="区域预警分布统计" scroll :active="active">
    <div class="content">
      <RegionCycleChart
        v-for="region of regionList"
        :key="region.regionName"
        :size-mode="sizeMode"
        :region="region"
      />
    </div>
  </ViewPanel>
</template>

<script>
import ViewPanel from '../Components/ViewPanel'
import RegionCycleChart from '../Components/RegionCycleChart.vue'
import DataSet from '@antv/data-set'
import * as api from '@/api'
import riskMonitoringMixins from '@/mixins/riskMonitoringMixins'

export default {
  name: 'RegionWarnDistribution',
  components: { ViewPanel, RegionCycleChart },
  inject: ['$riskMonitor'],
  mixins: [riskMonitoringMixins],
  props: {
    // 屏幕尺寸类型
    sizeMode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      regionList: []
    }
  },
  computed: {
    active() {
      return this.$riskMonitor.activePanel.toLowerCase() === this.$options.name.toLowerCase()
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    /**
     * 查询预警区域的统计
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getData() {
      const { data } = await api.emmsRiskMonitorQueryAlterEventRegion({
        data: { projectCode: this.$store.state.projectCode }
      })
      this.regionList = data.list
    },
    /**
     * 渲染地图
     * @author zhubincong
     * @date 2020-03-11 18:47:37
     */
    renderMap() {
      const { mapChart, mapView, mapDataView } = this.$riskMonitor
      // 清除其他业务图表
      mapView.clear()
      if (this.regionList.length === 0) {
        mapChart.repaint()
        return
      }
      const dv = new DataSet()
        .createView()
        .source(this.regionList)
        .transform({
          geoDataView: mapDataView,
          field: 'regionName',
          type: 'geo.region',
          binWidth: [2, 3],
          as: ['longitude', 'latitude']
        })
      mapView.source(dv)
      mapView.scale({
        rate: {
          type: 'linear'
        }
      })
      mapView
        .polygon()
        .position('longitude*latitude')
        .color('rate', this.getRegionRankBg)
        .tooltip('regionName*rate', (name, value) => ({ name, value: value + '%' }))
        .opacity(0.5)
        .active(true, {
          highlight: true // true 是否开启 highlight 效果，开启时没有激活的变灰
        })
      mapChart.legend(false)
      this.$riskMonitor.$refs.centerMapRef.showRangeRateLegend = true
      mapChart.repaint()
    },
    /**
     * 刷新数据
     * @author zhubincong
     * @date 2020-03-18 17:12:42
     */
    async refreshData() {
      await this.getData()
      if (this.active) this.renderMap()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .view-panel {
    width: 470px;
    height: 376px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .view-panel {
    width: 391px;
    height: 313px;
  }
}

@media screen and (max-width: 1599px) {
  .view-panel {
    width: 313px;
    height: 250px;
  }
}
</style>
